module.exports = __webpack_public_path__ + "img/EDU.9f3ec74b.svg";